import script from "./ContestManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestManagement.vue?vue&type=script&setup=true&lang=js"

import "./ContestManagement.vue?vue&type=style&index=0&id=25f95675&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f95675"]])

export default __exports__